// extracted by mini-css-extract-plugin
export default {"particleContainer":"Particles_particleContainer__052Cj","particle":"Particles_particle__9WSvc boxShadow","downHide":"Particles_downHide__MZF7f"};